const LOGGED_OUT_KEY = 'telome:logged-out';

export const markExplicitlyLoggedOut = () => {
  try {
    localStorage.setItem(LOGGED_OUT_KEY, '1');
  } catch {}
};

export const clearExplicitLogout = () => {
  try {
    localStorage.removeItem(LOGGED_OUT_KEY);
  } catch {}
};

export const isExplicitlyLoggedOut = () => {
  try {
    return localStorage.getItem(LOGGED_OUT_KEY) === '1';
  } catch {
    return false;
  }
};

export { LOGGED_OUT_KEY };
